import { useTheme } from "next-themes";
import { Sun, Moon, Monitor } from "lucide-react";
import { cn } from "@/lib/utils";

export const ThemeSettings = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();

  const themes = [
    { value: "light", label: "Light", icon: Sun, description: "Bright and clean" },
    { value: "dark", label: "Dark", icon: Moon, description: "Easy on the eyes" },
    { value: "system", label: "System", icon: Monitor, description: "Match your device" },
  ];

  const isActive = (value: string) => {
    if (value === "system") return theme === "system";
    return theme === value || (theme === "system" && resolvedTheme === value);
  };

  return (
    <div className="space-y-5">
      <div className="rounded-xl border border-border/60 bg-card p-5 sm:p-6">
        <h3 className="font-semibold mb-1">Theme</h3>
        <p className="text-sm text-muted-foreground mb-5">
          Choose how Email2Contact looks. Your choice is saved per device.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {themes.map(({ value, label, icon: Icon, description }) => {
            const active = isActive(value);
            return (
              <button
                key={value}
                onClick={() => setTheme(value)}
                className={cn(
                  "group relative rounded-xl border p-4 text-left transition-all",
                  "hover:border-primary/40 hover:shadow-fluent-4",
                  active
                    ? "border-primary/50 bg-primary/5 ring-1 ring-primary/20 shadow-fluent-2"
                    : "border-border/60 bg-card"
                )}
              >
                <div
                  className={cn(
                    "h-10 w-10 rounded-lg flex items-center justify-center mb-3 transition-colors",
                    active ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground group-hover:bg-primary/10 group-hover:text-primary"
                  )}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <p className="text-sm font-medium">{label}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
                {active && (
                  <div className="absolute top-3 right-3 h-2 w-2 rounded-full bg-primary animate-pulse" />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
